import ColorStyles from '@components/ColorStyles';
import BrDropdownMenuButton from './BrDropdownMenuButton';

BrDropdownMenuButton.ColorStyles = ColorStyles;
export default BrDropdownMenuButton;
